/**
 * @fileoverview added by tsickle
 * Generated from: models/job.mixin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Duration } from '../util/datetime/index';
import { defineModelProperties, model } from '../util/model';
import { ACCESS_CHOICES, ACCESS_DISPLAY } from './property';
import { TaskType } from './task';
/** @enum {number} */
var JobFrequency = {
    OneOff: 0,
    Weekly: 7,
    Fortnightly: 14,
    FourWeekly: 28,
};
export { JobFrequency };
JobFrequency[JobFrequency.OneOff] = 'OneOff';
JobFrequency[JobFrequency.Weekly] = 'Weekly';
JobFrequency[JobFrequency.Fortnightly] = 'Fortnightly';
JobFrequency[JobFrequency.FourWeekly] = 'FourWeekly';
/** @type {?} */
export var JOB_FREQUENCY_LABELS = new Map([
    [JobFrequency.OneOff, 'one off'],
    [JobFrequency.Weekly, 'every week'],
    [JobFrequency.Fortnightly, 'every 2 weeks'],
    [JobFrequency.FourWeekly, 'every 4 weeks']
]);
/**
 * Map for getting the consecutive skip count depending on the job frequency
 * before we offer a new housekeeper.
 * Weekly schedule: 3 consecutive skips are allowed before the warning
 * 2-weekly schedule: 2 consecutive skips are allowed before the warning
 * 4-weekly schedule: 2 consecutive skips is allowed before the warning
 * (4-weekly not available for new jobs)
 * @type {?}
 */
export var JOB_FREQUENCY_CONSECUTIVE_SKIP_WARNING_COUNT = new Map([
    [JobFrequency.Weekly, 3],
    [JobFrequency.Fortnightly, 2],
    [JobFrequency.FourWeekly, 2]
]);
/**
 * Model providing functionality common to both jobs and visits.
 * @record
 */
export function JobModelMixin() { }
if (false) {
    /** @type {?} */
    JobModelMixin.prototype.id;
    /** @type {?} */
    JobModelMixin.prototype.access;
    /** @type {?} */
    JobModelMixin.prototype.accessChoice;
    /** @type {?} */
    JobModelMixin.prototype.accessDisplay;
    /** @type {?} */
    JobModelMixin.prototype.accessOverride;
    /** @type {?} */
    JobModelMixin.prototype.accessOverrideDisplay;
    /** @type {?} */
    JobModelMixin.prototype.frequency;
    /** @type {?|undefined} */
    JobModelMixin.prototype.frequencyDisplay;
    /** @type {?} */
    JobModelMixin.prototype.getTask;
    /** @type {?} */
    JobModelMixin.prototype.hasTask;
    /** @type {?} */
    JobModelMixin.prototype.isOneOff;
    /** @type {?} */
    JobModelMixin.prototype.requiredDuration;
    /** @type {?} */
    JobModelMixin.prototype.tasks;
    /** @type {?} */
    JobModelMixin.prototype.accountId;
    /** @type {?} */
    JobModelMixin.prototype.anyWorker;
    /** @type {?} */
    JobModelMixin.prototype.hasTaskTypeInstruction;
    /** @type {?} */
    JobModelMixin.prototype.getTaskTypeInstructions;
    /** @type {?} */
    JobModelMixin.prototype.instructions;
    /** @type {?} */
    JobModelMixin.prototype.propertyId;
    /** @type {?} */
    JobModelMixin.prototype.requiresProducts;
    /** @type {?} */
    JobModelMixin.prototype.sortTasks;
    /** @type {?} */
    JobModelMixin.prototype.timeSlot;
    /** @type {?} */
    JobModelMixin.prototype.workerTasks;
    /** @type {?} */
    JobModelMixin.prototype.isAlive;
    /** @type {?} */
    JobModelMixin.prototype.isConfirmed;
    /** @type {?} */
    JobModelMixin.prototype.isUnassigned;
}
/**
 * Model providing functionality common to both jobs and visits.
 * @type {?}
 */
export var jobModelMixin = model.extend((/** @type {?} */ ({
    /**
     * Reset the state by applying a copy of the last saved state.
     */
    postStateChange: /**
     * Reset the state by applying a copy of the last saved state.
     * @return {?}
     */
    function () {
        this.sortTasks();
        this.isUnsaved = false;
        this.isKeysOnlyVisit = false;
    },
    /**
     * Sort the given tasks in-place alphabetically, but with cleaning always
     * at the top of the list.
     * @param tasks Task[]
     */
    sortTasks: /**
     * Sort the given tasks in-place alphabetically, but with cleaning always
     * at the top of the list.
     * @return {?}
     */
    function () {
        this.tasks = this.tasks || [];
        this.tasks.sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) {
            if (a.type === 'cleaning' || a.type < b.type) {
                return -1;
            }
            if (b.type === 'cleaning' || a.type > b.type) {
                return 1;
            }
            return 0;
        }));
    },
    hasTask: /**
     * @param {?} taskType
     * @return {?}
     */
    function (taskType) {
        return this.tasks.some((/**
         * @param {?} task
         * @return {?}
         */
        function (task) { return task.type === taskType; }));
    },
    getTask: /**
     * @param {?} taskType
     * @return {?}
     */
    function (taskType) {
        return this.tasks.find((/**
         * @param {?} task
         * @return {?}
         */
        function (task) { return task.type === taskType; }));
    },
    hasTaskTypeInstruction: /**
     * @param {?} taskType
     * @return {?}
     */
    function (taskType) {
        return this.instructions.some((/**
         * @param {?} instruction
         * @return {?}
         */
        function (instruction) { return instruction.taskType === taskType; }));
    },
    getTaskTypeInstructions: /**
     * @param {?} taskType
     * @return {?}
     */
    function (taskType) {
        return this.instructions.filter((/**
         * @param {?} instruction
         * @return {?}
         */
        function (instruction) { return instruction.taskType === taskType; }));
    }
})));
// Implements helper properties declared in `JobModelMixin`
defineModelProperties(jobModelMixin, {
    accessChoice: {
        get: /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var access = this.access || (this.property ? this.property.access : null);
            return ACCESS_CHOICES.get(access) || '';
        }
    },
    accessDisplay: {
        get: /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var access = this.access || (this.property ? this.property.access : null);
            return ACCESS_DISPLAY.get(access) || 'Unknown';
        },
        set: /**
         * @param {?} accessDisplay
         * @return {?}
         */
        function (accessDisplay) {
            // This needs to be set to avoid errors due to backend serializing access_display for visit serializer.
        }
    },
    accessOverrideDisplay: {
        get: /**
         * @return {?}
         */
        function () {
            return ACCESS_DISPLAY.get(this.accessOverride) || '';
        }
    },
    frequencyDisplay: {
        get: /**
         * @return {?}
         */
        function () {
            return JOB_FREQUENCY_LABELS.get(this.frequency);
        }
    },
    isOneOff: {
        get: /**
         * @return {?}
         */
        function () {
            return this.frequency === JobFrequency.OneOff;
        }
    },
    requiredDuration: {
        get: /**
         * @return {?}
         */
        function () {
            return this.getOrCache('requiredDuration', (/**
             * @return {?}
             */
            function () {
                if (this.isKeysOnlyVisit) {
                    return new Duration({ hours: 1 });
                }
                /** @type {?} */
                var hours = this.tasks
                    .filter((/**
                 * @param {?} task
                 * @return {?}
                 */
                function (task) { return task.isTimed; }))
                    .map((/**
                 * @param {?} task
                 * @return {?}
                 */
                function (task) { return task.hours; }))
                    .reduce((/**
                 * @param {?} a
                 * @param {?} b
                 * @return {?}
                 */
                function (a, b) { return a + b; }), 0);
                return new Duration({ hours: hours });
            }));
        }
    },
    requiresProducts: {
        get: /**
         * @return {?}
         */
        function () {
            return this.tasks.some((/**
             * @param {?} task
             * @return {?}
             */
            function (task) { return task.type === TaskType.Products; }));
        }
    },
    /**
     * Tasks actionable by the worker.
     */
    workerTasks: {
        get: /**
         * @return {?}
         */
        function () {
            return this.tasks.filter((/**
             * @param {?} task
             * @return {?}
             */
            function (task) { return task.isActionable; }));
        }
    }
});
